import axiosInstance from "./Axios";

export class SubscriptionApi {
  static getSubscriptionsList = async ({
    search,
    subscription_type,
    listing_type,
    page = 1,
    limit = 30,
  }: {
    search: string;
    subscription_type: string;
    listing_type: string;
    page?: number;
    limit?: number;
  }) => {
    try {
      const res = await axiosInstance.get(`client/subscriptions`, {
        params: {
          page,
          limit,
          created_at: "desc",
          search,
          subscription_type,
          listing_type,
        },
      });
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static assignSubscription = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `client/subscriptions/subscribe`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static getSubscriptionCommonFeaturesList = async ({
    search,
    status,
    page = 1,
    limit = 30,
    created_at = "desc",
  }: {
    search?: string;
    status?: string;
    page?: number;
    limit?: number;
    created_at?: "asc" | "desc";
  }) => {
    try {
      const res = await axiosInstance.get(
        `admin/subscriptions/common-features`,
        {
          params: {
            page,
            limit,
            created_at,
            search,
            status,
          },
        },
      );

      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong!",
        data: err?.response?.data,
      };
    }
  };

  static getMyActiveSubscription = async (filters: {
    subscription_type: string;
    listing_type: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/subscriptions/active-subscription-plan`,
        {
          params: filters,
        },
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Failed to fetch active subscription!",
        data: err?.response?.data,
      };
    }
  };

  static getMySubscriptionHistory = async (filters: {
    id?: string;
    subscription_type?: string;
    listing_type?: string;
     subscription_status?: string;
    page?: number;
    limit?: number;
    agent_id?: string;
    search?: string;
  }) => {
    try {
      const res = await axiosInstance.get(
        `client/subscriptions/agent-subscription-history`,
        { params: filters },
      );

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch subscription history!",
        data: err?.response?.data,
      };
    }
  };

  static getStripePaymentHistory = async (params?: {
    limit?: number;
    from_date?: string;
    to_date?: string;
    starting_after?: string;
    agent_id?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`/stripe/payment-history/me`, {
        params: {
          limit: params?.limit || 3,
          from_date: params?.from_date,
          to_date: params?.to_date,
          starting_after: params?.starting_after,
          agent_id: params?.agent_id,
        },
      });

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch payment history!",
        data: err?.response?.data,
      };
    }
  };

  static getAgentsPaymentHistory = async (params?: {
    limit?: number;
    from_date?: string;
    to_date?: string;
    starting_after?: string;
    agent_id?: string;
    billing_type?: string;
  }) => {
    try {
      const res = await axiosInstance.get(`/stripe/payment-history/agents`, {
        params: {
          limit: params?.limit || 10,
          from_date: params?.from_date,
          to_date: params?.to_date,
          starting_after: params?.starting_after,
          agent_id: params?.agent_id,
          billing_type: params?.billing_type,
        },
      });

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch agents payment history!",
        data: err?.response?.data,
      };
    }
  };

  static downloadCustomInvoice = async (fileName: string) => {
    try {
      const response = await axiosInstance.get(
        `/stripe/invoices/download/${fileName}`,
        {
          responseType: "blob",
        },
      );

      return {
        data: response.data,
        success: true,
      };
    } catch (err: any) {
      return {
        success: false,
        error: "Failed to download invoice!",
        data: err?.response?.data,
      };
    }
  };

  static createStripeCheckoutSession = async (payload: {
    stripe_price_id: string;
    agent_id: string;
    subscription_type: string;
    listing_type: string;
    subscription_plan_id: string;
    property_id?: string;
    property_address?: string;
    is_wallet_applied?: boolean;
    success_redirect_url?: string;
    cancel_redirect_url?: string;
    payment_method_source?: "agency" | "agent";
  }) => {
    try {
      const res = await axiosInstance.post(`/stripe/create-session`, payload);
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to create Stripe session!",
        data: err?.response?.data,
      };
    }
  };

static checkPropertyPlanStatus = async (propertyId: string) => {
  try {
    const res = await axiosInstance.get(`/stripe/check-status/${propertyId}`);
    return { 
      data: res.data 
    };
  } catch (err: any) {
    return {
      error: "Failed to verify property status!",
      data: err?.response?.data,
    };
  }
};

  static createAgentStripeCheckoutSession = async (payload: {
    stripe_price_id: string;
    agent_id: string;
    subscription_type: string;
    listing_type: string;
    subscription_plan_id: string;
    property_id?: string;
    property_address?: string;
    is_wallet_applied?: boolean;
    payment_method_source?: "agency" | "agent";
    success_redirect_url?: string;
    cancel_redirect_url?: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `/stripe/agent-create-session`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to create Stripe session!",
        data: err?.response?.data,
      };
    }
  };

  static checkAgentPlanStatus = async (subscription_type: string, listing_type: string) => {
  try {
    const res = await axiosInstance.get(`/stripe/check-agent-status`, {
      params: { 
        subscription_type, 
        listing_type 
      },
    });
    return { 
      data: res.data 
    };
  } catch (err: any) {
    return {
      error: "Failed to verify agent subscription status!",
      data: err?.response?.data,
    };
  }
};

  static upgradePropertyPlan = async (payload: {
    agent_id: string;
    property_id: string;
    old_plan_price: number;
    new_plan_price: number;
    new_plan_id: string;
    property_address?: string;
    is_wallet_applied?: boolean;
    success_redirect_url?: string;
  }) => {
    try {
      const res = await axiosInstance.post("/stripe/upgrade-plan", payload);

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to upgrade property plan!",
        data: err?.response?.data,
      };
    }
  };

  static getStripePricesBySubscriptionId = async (subscription_id: string) => {
    try {
      const res = await axiosInstance.get("/stripe/product/prices", {
        params: { subscription_id },
      });

      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch Stripe prices",
        data: err?.response?.data,
      };
    }
  };

  static updateSubscriptionHistory = async (
    data: any,
    subscription_history_id: string,
  ) => {
    try {
      const res = await axiosInstance.post(
        `subscription-history/update/${subscription_history_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static cancelStripeSubscription = async (payload: {
    stripe_subscription_id: string;
  }) => {
    try {
      const res = await axiosInstance.post(`/stripe/cancel`, payload);
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to cancel Stripe subscription!",
        data: err?.response?.data,
      };
    }
  };

  static cancelStripeSubscriptionWithRefund = async (payload: {
    stripe_payment_intent_id: string;
  }) => {
    try {
      const res = await axiosInstance.post(
        `/stripe/property-marketing-cancel-refund`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to cancel purchase!",
        data: err?.response?.data,
      };
    }
  };

  static createSetupIntent = async (payload: any) => {
    try {
      const res = await axiosInstance.post(
        `/stripe/create-setup-intent`,
        payload,
      );
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to create setup intent",
        data: err?.response?.data,
      };
    }
  };

  static getSavedCards = async (params: any) => {
    try {
      const res = await axiosInstance.get(`/stripe/saved-cards`, {
        params: params,
      });
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to fetch saved cards",
        data: err?.response?.data,
      };
    }
  };

  static setDefaultCard = async (payload: any) => {
    try {
      const res = await axiosInstance.post(`/stripe/set-default-card`, payload);
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to set default card",
        data: err?.response?.data,
      };
    }
  };

  static deleteSavedCard = async (payment_method_id: string) => {
    try {
      const res = await axiosInstance.post(`/stripe/delete-card`, {
        payment_method_id,
      });
      return { data: res.data };
    } catch (err: any) {
      return {
        error: "Failed to delete card",
        data: err?.response?.data,
      };
    }
  };
}
